<mat-dialog-content>
  <h1 i18n="TitleAcceptModifications | Título del Popup de aceptar cambios">Accept modifications</h1>
  <p i18n="DescriptionAcceptModifications | Mensaje del popup de aceptar modificaciones">You must accept modifications after making changes to continue.</p>
</mat-dialog-content>
<mat-dialog-actions class="d-flex justify-content-center mt-5">
  <button mat-stroked-button color="accent" (click)="onUnderstandClick()" i18n="AcceptmodificationsButton| Accept modifications price button">Close</button>
<!--  <button mat-flat-button color="primary" class="ml-3" i18n="UpgradePriceButton | Boton actualizar precio">Update price</button>-->
</mat-dialog-actions>
